export default "__VITE_ASSET__Cl83LzHl__"